import { EffectCallback, useEffect } from 'react';

export default (callback: EffectCallback) =>
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, []);
